import "./style/dark.scss";
import { useContext,useEffect, useState } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import { SnackbarUtilsConfigurator } from './components/Toast';
import { Zoom } from '@mui/material';
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { SnackbarProvider, useSnackbar } from 'notistack';
import AppRoutes from "./routes/Routes";
import { FiltersProvider } from "./context/FiltersContext";
import { getLoginEmpresasById } from "./services/EmpresaServices";
import useDocumentTitle from "./components/Title";

function App() {
  const { darkMode } = useContext(DarkModeContext);
  const [empresaData,setEmpresaData]=useState();
  const titleGrid = empresaData?.nombre_sitio
  ? `${empresaData.nombre_sitio} - Ecommerce`
  : "Ecommerce";


  useDocumentTitle(titleGrid);
    useEffect(() => {
      getEmpresaData();
    }, []);
  
    const getEmpresaData = async () => {
      try {
        if (!empresaData) {
          const empresaResponse = await getLoginEmpresasById(1);
          setEmpresaData(empresaResponse);
          localStorage.setItem("panelempresaData", JSON.stringify(empresaResponse));
        }
      } catch (error) {
        console.error("Error al obtener los datos de la empresa:", error);
      }
    };
  return (
    <div className={darkMode ? "app dark" : "app"}>
      <SnackbarProvider TransitionComponent={Zoom} autoHideDuration={3000} maxSnack={2}>
        <SnackbarUtilsConfigurator />
        <AuthProvider>
          <FiltersProvider>
            <AppRoutes />
          </FiltersProvider>
        </AuthProvider>
      </SnackbarProvider>
    </div>
  );
}

export default App;
